<label>{{ 'WS_DIRECTORY.EXPORT.TITLE' | translate }}</label>
<ng-container *gsShowIfHasPermission="['WS_DIRECTORY_EXPORT_CURRENT_SEARCH_READ']">
  <a (click)="export('currentSelection')" *ngIf="isFilterActive()">
    {{ 'WS_DIRECTORY.EXPORT.CURRENT_SELECTION' | translate }}
  </a>
</ng-container>

<a (click)="export('terminologyWorkbook')">
  {{ 'WS_DIRECTORY.EXPORT.TERMINOLOGY_WORKBOOK' | translate }}
</a>

<a (click)="export('scoutingAroundWorld')">
  {{ 'WS_DIRECTORY.EXPORT.SCOUTING_AROUND_WORLD' | translate }}
</a>
<ng-container *gsShowIfHasPermission="['WS_DIRECTORY_EXPORT_CONTACT_DETAILS_READ']">
  <a (click)="export('contactDetails')" *ngIf="isLoggedUser && user?.hasRole">
    {{ 'WS_DIRECTORY.EXPORT.CONTACT_DETAILS' | translate }}
  </a>
</ng-container>

<p-blockUI [blocked]="block">
  <div class="wrapper">
    <h4>{{ 'WS_DIRECTORY.EXPORT.PLEASE_WAIT' | translate }}</h4>
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</p-blockUI>

<p-confirmDialog icon="fa fa-question-circle" [style]="{width: '425px'}"></p-confirmDialog>
